import { createAction } from 'redux-act'
import { NOTIFICATION_CLEAR, NOTIFICATION_LOAD } from './action-types'
import { NotificationMessageState } from './types'

export const disposeNotification = createAction<NotificationMessageState>(NOTIFICATION_LOAD)
export const clearNotification = createAction<string>(NOTIFICATION_CLEAR)
